/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Follow_People_FollowingInputs */

const en_follow_people_following = /** @type {(inputs: Follow_People_FollowingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`People following ${i?.name}`)
};

const es_follow_people_following = /** @type {(inputs: Follow_People_FollowingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Personas que siguen a ${i?.name}`)
};

const fr_follow_people_following = /** @type {(inputs: Follow_People_FollowingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Personnes suivant ${i?.name}`)
};

const de_follow_people_following = /** @type {(inputs: Follow_People_FollowingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Personen, die ${i?.name} folgen`)
};

const id_follow_people_following = /** @type {(inputs: Follow_People_FollowingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Orang yang mengikuti ${i?.name}`)
};

/** @type {(inputs: Follow_People_FollowingInputs) => LocalizedString} */
const ja_follow_people_following = en_follow_people_following;

/** @type {(inputs: Follow_People_FollowingInputs) => LocalizedString} */
const zh_follow_people_following = en_follow_people_following;

/** @type {(inputs: Follow_People_FollowingInputs) => LocalizedString} */
const ar_follow_people_following = en_follow_people_following;

/** @type {(inputs: Follow_People_FollowingInputs) => LocalizedString} */
const it_follow_people_following = en_follow_people_following;

/** @type {(inputs: Follow_People_FollowingInputs) => LocalizedString} */
const ru_follow_people_following = en_follow_people_following;

/** @type {(inputs: Follow_People_FollowingInputs) => LocalizedString} */
const pt_follow_people_following = en_follow_people_following;

/** @type {(inputs: Follow_People_FollowingInputs) => LocalizedString} */
const ko_follow_people_following = en_follow_people_following;

/**
* | output |
* | --- |
* | "People following {name}" |
*
* @param {Follow_People_FollowingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const follow_people_following = /** @type {((inputs: Follow_People_FollowingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_People_FollowingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_follow_people_following(inputs)
	if (locale === "es") return es_follow_people_following(inputs)
	if (locale === "fr") return fr_follow_people_following(inputs)
	if (locale === "de") return de_follow_people_following(inputs)
	if (locale === "ja") return ja_follow_people_following(inputs)
	if (locale === "zh") return zh_follow_people_following(inputs)
	if (locale === "ar") return ar_follow_people_following(inputs)
	if (locale === "id") return id_follow_people_following(inputs)
	if (locale === "it") return it_follow_people_following(inputs)
	if (locale === "ru") return ru_follow_people_following(inputs)
	if (locale === "pt") return pt_follow_people_following(inputs)
	return ko_follow_people_following(inputs)
});